import { render } from "./ReportsDetailsShow.vue?vue&type=template&id=a9fd0940"
import script from "./ReportsDetailsShow.vue?vue&type=script&lang=js"
export * from "./ReportsDetailsShow.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\JOGA\\Desktop\\Projekty\\Trash3\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__